import { useParams } from 'react-router-dom';

import { useProductUpdateFormik } from '../hooks/use-product-update-formik';

import { AdminUpdateBreadcrumb } from '../ui/admin-update-breadcrumb';
import { AdminProductFields } from '../ui/admin-product-fields';
import { AdminSpinner } from '../ui/admin-spinner';

// Mock schema / remove after BE integration
import { schema } from '../constants/plan-schema-mock';

export const AdminPlanUpdate = () => {
  const { type } = useParams();
  const { formik, disabled, disableToggle, isLoading } =
    useProductUpdateFormik();

  return (
    <form onSubmit={formik.handleSubmit}>
      <AdminUpdateBreadcrumb
        type={type as string}
        disableToggle={disableToggle}
        isLoading={isLoading}
        disabled={disabled}
      />
      <AdminProductFields
        formik={formik}
        disabled={disabled}
        schema={schema}
      />
      <AdminSpinner loading={isLoading} fullScreen />
    </form>
  );
};
